import React, { useEffect } from 'react';

import { Alert } from 'components/cosmos/alert';
import { I18n } from 'components/translate';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import { useResendAccessContext } from 'modules/onlineEvent/context/resendAccess';
import PropTypes from 'prop-types';

import { sendCancelEvent, sendConfirmEvent, sendViewEvent } from './events';

const BannerResendAccess = ({ events = [] }) => {
  const {
    bannerIsOpen,
    setBannerIsOpen,
    setModalIsOpen,
    setSendLaterModalIsOpen
  } = useResendAccessContext();

  useEffect(() => {
    sendViewEvent();
  }, []);

  useEffect(() => {
    if (events.includes(EVENTS.ONLINE_EVENT_TOMORROW_NOTIFY)) {
      setBannerIsOpen(true);
    }
  }, [events, setBannerIsOpen]);

  const handleConfirm = () => {
    sendConfirmEvent();
    setModalIsOpen(true);
  };

  const handleCancel = () => {
    sendCancelEvent();
    MembershipEventService.dismissEvent(EVENTS.ONLINE_EVENT_TOMORROW_NOTIFY);
    setBannerIsOpen(false);
    setSendLaterModalIsOpen(true);
  };

  if (!bannerIsOpen) {
    return null;
  }

  return (
    <Alert className="_my-6" type="info">
      <div>
        <strong>
          <I18n label="online_event.resend_access.banner.title" />
        </strong>
      </div>
      <div>
        <I18n label="online_event.resend_access.banner.description" />
      </div>
      <div className="_mt-3">
        <button
          className="hot-button hot-button--primary"
          onClick={handleConfirm}
        >
          <I18n label="online_event.resend_access.banner.send_button" />
        </button>
        <button
          className="hot-button hot-button--secondary _ml-3"
          onClick={handleCancel}
        >
          <I18n label="online_event.resend_access.banner.cancel_button" />
        </button>
      </div>
    </Alert>
  );
};

BannerResendAccess.propTypes = {
  onConfirm: PropTypes.func,
  events: MobxPropTypes.observableArray
};

export default BannerResendAccess;
